type CookieList = Record<string, string>;

const getCookie = (name: string): string | undefined => {
    if (document.cookie) {
        const cookieList: CookieList = document.cookie
            .split('; ')
            .reduce((cookieList: CookieList, keyVal: string) => {
                const parts = keyVal.split('=');
                cookieList[parts[0]] = parts[1];
                return cookieList;
            }, {});
        return cookieList[name];
    }
    return undefined;
};

export { getCookie };
